// src/styles/WaitlistStyle.js
export const classes = {
  // The main container for the entire page
  waitlistContainer: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  // Logo Container at the top
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem 2rem',
    // Add spacing or positioning as needed
  },

  // Logo image placeholder (replace once SVG is imported)
  logo: {
    width: '140px',
    height: 'auto',
    // Adjust as needed
  },

  // The main "hero" area containing the screenshot (left) + text (right)
  heroSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '2rem',
    '@media (max-width: 900px)': {
      padding: '1rem',
      flexDirection: 'column',
      textAlign: 'center',
    },
  },

  // Left column with the screenshot
  leftColumn: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative', // needed if you're placing a circle behind
    '@media (max-width: 900px)': {
      marginBottom: '2rem',
    },
  },

  backgroundBlueCircle: {
    zIndex: -1,
    position: 'absolute',
    width: '125%',
    height: '125%',
    borderRadius: '125%',
    backgroundColor: '#4ABFFD',
    opacity: 0.15,
    filter: 'blur(40px)',
    '@media (max-width: 900px)': {
      width: '100%',
      height: '100%',
    },
  },

  // The screenshot image
  screenshotImage: {
    width: '100%',
    maxWidth: '562px',
    height: 'auto',
    borderRadius: '12px',
    boxShadow: '0 4px 15px rgba(74,191,253,0.5)',
    transition: 'transform 0.2s ease-out',
  },

  // Right column containing badge, title, text, bullets, and waitlist form
  rightColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginLeft: '3rem',
    '@media (max-width: 900px)': {
      alignItems: 'center',
      marginLeft: '0',
    },
  },

  // Small badge container (e.g. "TWITTER AI AGENT")
  badge: {
    backgroundColor: '#2A2A2A', // subtle highlight color
    padding: '4px 16px',
    borderRadius: '100px',
    marginBottom: '1rem',
  },

  // Badge text styling
  badgeText: {
    fontWeight: 600,
    color: '#FFF',
    fontSize: '0.75rem',
  },

  // Main title (e.g. "Put your Twitter on auto-pilot")
  title: {
    fontSize: '2.5rem',
    fontWeight: 700,
    marginBottom: '1rem',
    lineHeight: 1.2,
    '@media (max-width: 600px)': {
      fontSize: '2rem',
    },
  },

  // Subtitle paragraph
  subtitle: {
    fontSize: '1rem',
    marginBottom: '1.5rem',
    maxWidth: '600px',
    fontWeight: 500,
    '@media (max-width: 900px)': {
      maxWidth: '100%',
    },
  },

  // Parent <ul> for bullet points
  featureList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
    marginBottom: '1rem',
  },

  // Each <li> item uses an icon instead of bullets
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.75rem',
  },

  listItem: {
    textAlign: 'left',
  },

  // The check icon image
  checkIcon: {
    width: '20px',
    height: '20px',
    marginRight: '8px',
  },

  /**
   * Waitlist form container
   * Renders the input + button in one pill-shaped box
   */
  waitlistForm: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '480px',
    marginBottom: '1rem',
    backgroundColor: '#fff',
    borderRadius: '999px',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
    /* ↓ Reduced overall padding for a smaller height */
    padding: '0.3rem 0.3rem 0.3rem 0.75rem',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      borderRadius: '20px',
      padding: '0.75rem', // still bigger on small screens
    },
  },

  // Email input field
  emailInput: {
    flex: 1,
    marginRight: '0.5rem', // narrower gap
    '& .MuiOutlinedInput-root': {
      borderRadius: '999px',
      // Remove default outline, rely on container
      '& fieldset': {
        border: 'none',
      },
    },
    /* ↓ Slimmer text field padding for a smaller look */
    '& .MuiOutlinedInput-input': {
      padding: '0.5rem 0.75rem',
      fontSize: '0.9rem', // optional: smaller text
    },
    '@media (max-width: 600px)': {
      marginRight: 0,
      marginBottom: '0.75rem',
      width: '100%',
    },
  },

  // "JOIN WAITLIST" button
  joinButton: {
    fontSize: '0.9rem',
    whiteSpace: 'nowrap',
    backgroundColor: '#2A2A2A',
    color: '#fff',
    borderRadius: '999px',
    /* ↓ Less padding for a smaller overall button */
    padding: '0.5rem 1rem',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#424242',
    },
    '@media (max-width: 600px)': {
      width: '100%',
    },
  },

  // Footnote (e.g. "Psst... early members get access to the free tier!")
  footnote: {
    fontSize: '0.85rem',
    color: '#757575',
  },
};
